export enum EDateFormat {
  ISO = 'ISO',
  EUROPEAN = 'EUROPEAN',
  US = 'US',
  FRIENDLY = 'FRIENDLY',
}
